var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "t-dialog t-dialog--top",
      attrs: {
        title: "保存模板",
        visible: _vm.open,
        width: "500px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.open = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "80px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "封面图", prop: "coverImg" } },
            [
              _c("imageUpload", {
                model: {
                  value: _vm.form.coverImg,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "coverImg", $$v)
                  },
                  expression: "form.coverImg",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "模板名称", prop: "name" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入模板名称" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "模板描述", prop: "description" } },
            [
              _c("el-input", {
                attrs: { type: "textarea", placeholder: "请输入模板描述" },
                model: {
                  value: _vm.form.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "模板类型", prop: "categoryId" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择项目类型" },
                  model: {
                    value: _vm.form.categoryId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "categoryId", $$v)
                    },
                    expression: "form.categoryId",
                  },
                },
                _vm._l(_vm.templateTypeList, function (temp) {
                  return _c("el-option", {
                    key: temp.id,
                    attrs: { label: temp.name, value: temp.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
            [_vm._v(" 确 定 ")]
          ),
          _c("el-button", { on: { click: _vm.cancel } }, [_vm._v(" 取 消 ")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }